module.exports = __webpack_public_path__ + "static/wave-9b11389f2914792a985bf930254209e8.mp4";